import { Modal } from 'components/Modal';
import styles from './ModalPayments.module.scss';
import moment from 'moment';
import { useEffect, useState } from 'react';

export interface DocumentsDataTypes {
  last_sent_documents: [
    {
      id: string;
      first_name: string;
      last_name: string;
      birth_date: string;
      issue_date: string;
      issuer_code: string;
      middle_name: string;
      number: string;
      series: string;
      type: string;
      validation_process: {
        status: string;
      };
    },
    {
      birth_place: string;
      id: string;
      inn: string;
      type: string;
      validation_process: {
        status: string;
      };
    },
  ];
  valid_documents: [
    {
      birth_date: string;
      expired_at: string;
      first_name: string;
      id: string;
      issue_date: string;
      issuer_code: string;
      last_name: string;
      middle_name: string;
      number: string;
      series: string;
      type: string;
    },
    {
      birth_place: string;
      expired_at: string;
      id: string;
      inn: string;
      type: string;
    },
  ];
}

type LastSentPassportDocument = DocumentsDataTypes['last_sent_documents'][0];
type LastSentInnDocument = DocumentsDataTypes['last_sent_documents'][1];
type ValidPassportDocument = DocumentsDataTypes['valid_documents'][0];
type ValidInnDocument = DocumentsDataTypes['valid_documents'][1];

export const ModalDocumentsBeneficiar = ({
  isShowDocumentsBeneficiarModal,
  setIsShowDocumentsBeneficiarModal,
  documentsData,
}: {
  isShowDocumentsBeneficiarModal: boolean;
  setIsShowDocumentsBeneficiarModal: (e: boolean) => void;
  documentsData: DocumentsDataTypes | null;
}) => {
  const [lastSentDocumentsPasport, setLastSentDocumentsPasport] =
    useState<LastSentPassportDocument | null>(null);
  const [lastSentDocumentsInn, setLastSentDocumentsInn] =
    useState<LastSentInnDocument | null>(null);
  const [validDocumentsPasport, setValidDocumentsPasport] =
    useState<ValidPassportDocument | null>(null);
  const [validDocumentsInn, setValidDocumentsInn] = useState<ValidInnDocument | null>(
    null,
  );

  useEffect(() => {
    if (documentsData?.last_sent_documents?.length) {
      if (documentsData?.last_sent_documents?.[0]?.type === 'inn_f') {
        setLastSentDocumentsInn(
          documentsData?.last_sent_documents?.[0] as unknown as LastSentInnDocument,
        );
        setLastSentDocumentsPasport(
          documentsData?.last_sent_documents?.[1] as unknown as LastSentPassportDocument,
        );
      } else {
        setLastSentDocumentsPasport(documentsData?.last_sent_documents?.[0]);
        setLastSentDocumentsInn(documentsData?.last_sent_documents?.[1]);
      }
    }

    if (documentsData?.valid_documents?.length) {
      if (documentsData?.valid_documents?.[0]?.type === 'inn_f') {
        setValidDocumentsInn(
          documentsData?.valid_documents?.[0] as unknown as ValidInnDocument,
        );
        setValidDocumentsPasport(
          documentsData?.valid_documents?.[1] as unknown as ValidPassportDocument,
        );
      } else {
        setValidDocumentsPasport(documentsData?.valid_documents?.[0]);
        setValidDocumentsInn(documentsData?.valid_documents?.[1]);
      }
    }
  }, [documentsData]);

  useEffect(() => {
    if (!isShowDocumentsBeneficiarModal) {
      setLastSentDocumentsPasport(null);
      setLastSentDocumentsInn(null);
      setValidDocumentsPasport(null);
      setValidDocumentsInn(null);
    }
  }, [isShowDocumentsBeneficiarModal]);

  return (
    <Modal
      setOpen={setIsShowDocumentsBeneficiarModal}
      open={isShowDocumentsBeneficiarModal}>
      <div className={styles.root}>
        <p className={styles.title}>Статус документов</p>

        <div style={{ display: 'flex', gap: '30px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <span className={styles.documents_block_title}>
              Последние отправленные документы
            </span>
            {lastSentDocumentsPasport && lastSentDocumentsInn ? (
              <>
                <div className={styles.documents_block_wrapper}>
                  <div className={styles.documents_block}>
                    <p>id:</p> <span>{lastSentDocumentsPasport?.id}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Имя:</p>
                    <span>{lastSentDocumentsPasport?.first_name}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Фамилия:</p>
                    <span>{lastSentDocumentsPasport?.last_name}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Отчество:</p>
                    <span>{lastSentDocumentsPasport?.middle_name}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Дата рождения:</p>
                    <span>
                      {moment(lastSentDocumentsPasport?.birth_date).format('DD.MM.YYYY')}
                    </span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Тип:</p>
                    <span>{lastSentDocumentsPasport?.type}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Серия:</p>
                    <span>{lastSentDocumentsPasport?.series}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Номер:</p>
                    <span>{lastSentDocumentsPasport?.number}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Дата выдачи:</p>
                    <span>
                      {moment(lastSentDocumentsPasport?.issue_date).format('DD.MM.YYYY')}
                    </span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Код подразделения:</p>
                    <span>{lastSentDocumentsPasport?.issuer_code}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Статус валидации:</p>
                    <span>{lastSentDocumentsPasport?.validation_process?.status}</span>
                  </div>
                </div>
                <div className={styles.documents_block_wrapper}>
                  <div className={styles.documents_block}>
                    <p>id:</p>
                    <span>{lastSentDocumentsInn?.id}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Место рождения:</p>
                    <span>{lastSentDocumentsInn?.birth_place}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>ИНН:</p>
                    <span>{lastSentDocumentsInn?.inn}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Тип:</p>
                    <span>{lastSentDocumentsInn?.type}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Статус валидации:</p>
                    <span>{lastSentDocumentsInn?.validation_process?.status}</span>
                  </div>
                </div>
              </>
            ) : (
              <div className={styles.documents_block_wrapper}>
                Нет отправленных документов
              </div>
            )}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <span className={styles.documents_block_title}>
              Отвалидированные документы
            </span>
            {validDocumentsPasport && validDocumentsInn ? (
              <>
                <div className={styles.documents_block_wrapper}>
                  <div className={styles.documents_block}>
                    <p>id:</p> <span>{validDocumentsPasport?.id}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Имя:</p>
                    <span>{validDocumentsPasport?.first_name}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Фамилия:</p>
                    <span>{validDocumentsPasport?.last_name}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Отчество:</p>
                    <span>{validDocumentsPasport?.middle_name}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Дата рождения:</p>
                    <span>
                      {moment(validDocumentsPasport?.birth_date).format('DD.MM.YYYY')}
                    </span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Тип:</p>
                    <span>{validDocumentsPasport?.type}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Серия:</p>
                    <span>{validDocumentsPasport?.series}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Номер:</p>
                    <span>{validDocumentsPasport?.number}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Дата выдачи:</p>
                    <span>
                      {moment(validDocumentsPasport?.issue_date).format('DD.MM.YYYY')}
                    </span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Действителен до:</p>
                    <span>
                      {moment(validDocumentsPasport?.expired_at).format('DD.MM.YYYY')}
                    </span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Код подразделения:</p>
                    <span>{validDocumentsPasport?.issuer_code}</span>
                  </div>
                </div>
                <div className={styles.documents_block_wrapper}>
                  <div className={styles.documents_block}>
                    <p>id:</p>
                    <span>{validDocumentsInn?.id}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Место рождения:</p>
                    <span>{validDocumentsInn?.birth_place}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>ИНН:</p>
                    <span>{validDocumentsInn?.inn}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Тип:</p>
                    <span>{validDocumentsInn?.type}</span>
                  </div>
                  <div className={styles.documents_block}>
                    <p>Действителен до:</p>
                    <span>
                      {validDocumentsInn?.expired_at
                        ? moment(validDocumentsInn?.expired_at).format('DD.MM.YYYY')
                        : null}
                    </span>
                  </div>
                </div>
              </>
            ) : (
              <div className={styles.documents_block_wrapper}>
                Нет документов прошедших валидацию
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};
